// extracted by mini-css-extract-plugin
module.exports = {"container":"EmptyScheduleMessage_container__dLZE8"};